import {FC} from 'react'
import {Link} from 'react-router-dom'

const Error404: FC = () => {
  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>{'Oops!'.toTranslatedDisplay()}</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-500 mb-7'>{"We can't find that page.".toTranslatedDisplay()}</div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-3'>
        <i className='bi bi-signpost-split text-primary' style={{fontSize: '8rem'}} />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className='mb-0'>
        <Link to='/dashboard' className='btn btn-sm btn-primary'>
          {'Return Home'.toTranslatedDisplay()}
        </Link>
      </div>
      {/* end::Link */}
    </>
  )
}

export {Error404}
